import SpriteSymbol from "../../../../../../../../ldplatform/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../ldplatform/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-expand",
  "use": "icon-expand-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-expand\"><path d=\"M0 0v1024h1024V0z m921.6 921.6H102.4V102.4h819.2z\" p-id=\"7807\" /><path d=\"M204.8 460.8h614.4v102.4H204.8z\" p-id=\"7808\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol